import { ensure_string, ensure_array } from './ensure_utils.js';

export function cleanText(input: any): any {
  // Replace delimiters with spaces and split
  const str = ensure_string(input);
  const words = str.replace(/[_.-]/g, ' ') // Replace _, -, . with space
  return words

}
export function cleanArray(obj: any) {
  obj = ensure_array(obj);
  return Array.from(new Set(obj));
}
export function getCleanArray(obj: any) {

  obj = obj.split(/\s+/) // Split on any whitespace
    .filter((item: any): item is string => typeof item === 'string' && item !== '');
  // Get basename
  // Remove duplicates using Set
  const uniqueWords = cleanArray(obj);

  return uniqueWords;
}
// Cache a formatter instance for slightly better performance
const US_DECIMAL_FORMATTER = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatNumber<T>(value: T): string | T {
  try {
    // coerce to number
    const num = Number(value as any);
    // if it's NaN or infinite, bail out
    if (!isFinite(num)) return value;
    return US_DECIMAL_FORMATTER.format(num);
  } catch {
    // if anything goes wrong, return the original
    return value;
  }
}
